import {
  animate,
  query,
  sequence,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';

const cascadingSequence = sequence([
  animate('.35s ease', style({
    opacity: '.2',
    transform: 'translateY(0)',
  })),
  animate('.35s ease', style({
    opacity: '1',
  })),
]);

export const blsUpdateRowAnimation =
    trigger('blsUpdateRowAnimation', [
      // wildcard '*' matches any state including when animated el. is not rendered ('void')
      transition('* => *', [ // each time the binding value changes
        query(':enter', [ // animate rows entering view (void => *)
          style({
            opacity: '0',
            transform: 'translateY(-48px)',
          }),
          stagger(30, // applies a cascading delay to animations for multiple elements
              [cascadingSequence]),
        ], { optional: true }), // prevent error when no data row is selected
      ]),
    ]);

export const blsGmbDifferenceRowAnimation =
    trigger('blsGmbDifferenceRowAnimation', [
      transition('stop => start', [
        query('mat-row', [
          style({
            opacity: '0',
            transform: 'translateY(-350px)',
          }),
          stagger(100, // applies a cascading delay to animations for multiple elements
              [cascadingSequence]),
        ], { optional: true }), // prevent error when no data row is selected
      ]),
    ]);